// @flow

import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

import {SweetLoadingBar} from 'app/general/sweet-loading-bar';

const StyledContainerDIV = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 250px;
  border-right: 1px solid ${colors.borderGray};
  background: #fff;

  @media (max-width: 575px) {
    position: absolute;
  }
`;

const StyledHeaderDIV = styled.div`
  flex: 0 0 auto;
  background: ${colors.lightGray};
  z-index: 1;
`;

const StyledFooterContainerDIV = styled.div`
  flex: 0 0 auto;
`;

const StyledContentDIV = styled.div`
  flex: 1 1 auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  .list-group {
    border-radius: 0;
  }

  .list-group-item {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

const StyledTitleH5 = styled.h5`
  font-size: 0.95em;
  text-transform: uppercase;
  font-weight: bold;
  margin: 15px;

  .close {
    float: right;
    padding: 2px;
    font-size: 100%;
  }
`;

export const StyledFooterDIV = styled.div.attrs({
  className: 'text-center',
})`
  padding: 10px 15px;
  background: ${colors.lightGray};
`;

type Props = {
  showCloseButton?: boolean;
  title: React.ReactNode;
  additionalHeader?: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  loading?: boolean;
};

export function DocSidebarPagePanels({
  title,
  additionalHeader,
  onClose,
  children,
  footer,
  showCloseButton = true,
  loading = false,
}: Props): JSX.Element {
  return (
    <StyledContainerDIV>
      <StyledHeaderDIV>
        <StyledTitleH5>
          {showCloseButton ? (
            <button className="close" onClick={onClose}>
              <i className="fa fa-times" />
            </button>
          ) : null}
          {title}
        </StyledTitleH5>
        {additionalHeader != null ? additionalHeader : null}
        <div className="position-relative">
          <SweetLoadingBar loading={loading === true ? 1 : 0} />
        </div>
      </StyledHeaderDIV>
      <StyledContentDIV>{children}</StyledContentDIV>
      <StyledFooterContainerDIV>{footer}</StyledFooterContainerDIV>
    </StyledContainerDIV>
  );
}

/* SidebarSectionHeader: a component to render headings for sidebar sections */

const StyledSectionContainerDiv = styled.div.attrs<{className: string}>({
  className: 'px-3 py-2',
})`
  background: ${colors.lightGray};
  position: relative;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  letter-spacing: -0.25pt;
  font-size: 0.8em;
`;

export const StyledTitleContainer = styled.div.attrs({
  className: 'd-flex justify-content-between align-items-center',
})`
  position: relative;

  h5 {
    font-size: 1em;
    text-transform: uppercase;
    font-weight: bold;
    margin: 6px 0;
  }

  a {
    font-size: 0.8em;
  }
`;

interface SidebarSectionHeaderProps {
  containerClass?: string;
  title: React.ReactNode;
  help?: React.ReactNode;
  actionButton?: React.ReactNode;
  children?: React.ReactNode;
}

export function SidebarSectionHeader({
  containerClass,
  title,
  help,
  actionButton,
  children,
}: SidebarSectionHeaderProps): JSX.Element {
  return (
    <StyledSectionContainerDiv className={containerClass}>
      <StyledTitleContainer>
        <h5>{title}</h5>
        {actionButton != null ? (
          <div className="d-flex flex-nowrap align-items-center">
            {actionButton}
          </div>
        ) : null}
      </StyledTitleContainer>
      {help}
      {children != null ? (
        <div className="border-top pt-2 mt-2">{children}</div>
      ) : null}
    </StyledSectionContainerDiv>
  );
}
